<template>
<div style="padding:12px;height: 100%;box-sizing: border-box;max-width: 100%;overflow-x: auto" id="zongk" >
<el-row style="max-height: 100%;">
    <div style="width: 70%;float: left">
        <div style="margin-bottom: 10px;">
          <span style="padding: 0 15px">排课记录</span>
          <el-button size="mini" round class="boxshadow " :class="{activex:(xuan==pki)}" @click="zhouqs(pki,pk.start_time,pk.end_time)"
           v-for="(pk,pki) in week_time" :key="pki">{{pk.start_time_status}}<span v-if="pki == xuan">--{{pk.end_time}} ({{pk.diff_week}}周)</span></el-button>
        </div>
        <div style="overflow: scroll;height:80vh;">
            <el-col :span="24" id="wid1" >
                <el-row style="min-height: 400px">
                    <el-col :span="4" class="xingqBoxb" v-for="(kea,index) in lieb" :key="index" >
                        <div class="text-center xingqit" v-bind:class="{activea:(kea.jt)}"  v-cloak>{{kea.week}}</div>
                        <div class="xingqib">
                            <div class="kechengka" v-for="ke in kea.data" v-on:click="tiao(ke.ja_id,ke.kc_id)" >
                                <span v-if="ke.is_bk==2"  class="fa fa-check-circle duigou"></span>
                                <span  v-if="ke.is_bk==1"  class="fa fa-exclamation-circle tanhao"></span>
                                <p class="kechengm hang1" v-cloak>{{ke.kc_name}}</p>
                                <p class="text-center beikeren hang1" v-cloak style="font-size: 10px">
                                    <span>{{ke.bk}}</span> 人已完成
                                </p>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
        </div>
    </div>


    <el-col :span="8" id="youc" style="padding-left: 10px;padding-right: 0;width: 30%!important;box-sizing: border-box;">
        <div style="width: 100%;background: #fff;min-height:200px;padding: 10px;margin-bottom: 10px;border-radius: 10px;position: relative">
            <img src="/static/qmsj/img/tuijian.png" style="width: 100px" alt="">
            <div class="fix" style="zoom: 1;">
                <div class="kechengka fl" v-for="ke in zhongd" v-on:click="tiao(ke.id,ke.kc_id)">
                    <span   class="fa fa-star duigou" style="color: #00cce4"></span>
                    <p class="kechengm hang1" v-cloak>{{ke.kc_name}}</p>
                    <p class="text-center beikeren hang1">
                        <span v-cloak>{{ke.bk}}</span> 人已完成
                    </p>
                </div>
				<div style="clear: both;"></div>
            </div>
        </div>

        <div style="width: 100%;background: #fff;padding: 10px;min-height:200px;border-radius: 10px ">
            <img src="/static/qmsj/img/zhongd.png" style="width: 100px" alt="">
            <div class="fix">
                <div class="kechengka fl" v-for="ke in tuijian" v-on:click="tiao(ke.id,ke.kc_id)">
                    <span   class="fa fa-heart duigou" style="color: #ff797c"></span>
                    <p class="kechengm hang1" v-cloak>{{ke.kc_name}}</p>
                    <p class="text-center beikeren hang1">
                        <span v-cloak>{{ke.bk}}</span> 人已完成
                    </p>
                </div>
				<div style="clear: both;"></div>
            </div>
        </div>
    </el-col>

</el-row>

</div>
</template>

<script>
    export default {
        data() {
            return{
                lieb:'',
                zhongd:'',
                tuijian:'',
                token:'',
                week_time:'',
                shaist: '',
                shaiet: '',
                xuan:'false',

            }

        },
        methods:{
            tiao:function (iid,kc_id) {
                this.$router.push({
                    name: 'jiaoanx',
                    query: {
                       jiaoid: iid,
                       start_time:this.shaist,
                       end_time:this.shaiet,
                       kc_id:kc_id
                    }
                })
            },
            jump:function (d) {
                this.$router.push(d)
            },
            change:function(item,index){
                console.log(item);
                this.value[index]=item;
            },
            buqian:function (i) {
                this.dialogVisible=true
            },
            zhouqs: function(pk, stime, etime) {
            	this.xuan = pk;
              console.log(this.xuan);
            	this.shaist = stime;
            	this.shaiet = etime;
            	let self = this;
            	// self.head_date();
              self.get_data();
            },
            head_date:function(){
              let self = this;
              $.ajax({
                url:process.env.apiUrl + 'saas/jiaoan/week_time',
                type:'post',
                data:{
                  token:self.token,
                  start_time:self.shaist,
                  end_time:self.shaiet
                },
                success:function(data){
                  if(data.status = 1){
                    self.week_time = data.data
                    for (var i = 0; i < data.data.length; i++) {
                    	if(data.data[i].status == 1) {
                          self.xuan = i
                          self.shaist = data.data[i].start_time
                          self.shaiet = data.data[i].end_time
                    	}
                    }
                    self.get_data();
                  }

                }
              })
            },
            get_data:function(){
              let self = this;
              $.ajax({
                  url:process.env.apiUrl + "saas/jiaoan/ja",
                  type:"post",
                  dataType:'json',
                  data:{
                      token:self.token,
                      start_time:self.shaist,
                      end_time:self.shaiet
                  },
                  success:function(data){
                      self.lieb=data.data;
                      self.$nextTick(function () {
                          $('#wid1').width($('.xingqBoxb').width()*$('.xingqBoxb').length+'px');

                      })
                  }
              });
            }

        },
        mounted:function(){
           // var gangwei='{$gangwei}';
           // if(gangwei!='老师'){
           //     alert('你不是老师岗位，不能访问');
           //     window.history.go(-1);
           // }
            var self=this;
            self.token=self.$cookies.get('token');
            self.head_date();
            // self.get_data();
            // $.ajax({
            //     url:process.env.apiUrl + "saas/jiaoan/ja",
            //     type:"post",
            //     dataType:'json',
            //     data:{
            //         token:self.token
            //     },
            //     success:function(data){
            //         self.lieb=data.data;
            //        // self.$nextTick(function () {
            //        // })
            //         self.$nextTick(function () {
            //             $('#wid1').width($('.xingqBoxb').width()*$('.xingqBoxb').length+'px');
            //            // setTimeout(function () {
            //            //     $('#wid1').width($('.xingqBoxb').width()*$('.xingqBoxb').length+'px');
            //            //     $('#youc').width( $('#zongk').width()-$('#wid1').width()-30+'px')
            //            // },10)
            //            // setTimeout(function () {
            //            //     $('#wid1').width($('.xingqBoxb').width()*$('.xingqBoxb').length+'px');
            //            //     $('#youc').width( $('#zongk').width()-$('#wid1').width()-30+'px')
            //            // },10)
            //            // setTimeout(function () {
            //            //     $('#wid1').width($('.xingqBoxb').width()*$('.xingqBoxb').length+'px');
            //            //     $('#youc').width( $('#zongk').width()-$('#wid1').width()-30+'px')
            //            // },10)
            //         })
            //     }
            // });
            $.ajax({
                url:process.env.apiUrl + "saas/jiaoan/sc",
                type:"post",
                dataType:'json',
                data:{
                    token:self.token
                },
                success:function(data){
                    self.zhongd=data.data;

                }
            });
            $.ajax({
                url:process.env.apiUrl + "saas/jiaoan/tj",
                type:"post",
                dataType:'json',
                data:{
                    token:self.token
                },
                success:function(data){
                    self.tuijian=data.data;
                }
            });
        }
    }
</script>
<style scoped>
    *{
        box-sizing: border-box;
    }
    .activex {
    	color: #E6BE8A;
    	border-color: #E6BE8A;
    }
    #zongk{background: #ededed;max-height: 100%;overflow-y: scroll}
    .xingqit.activea{
        background: #f1f1f1;
    }
    .fl{
        float: left;
    }
    .hang1{
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .hang2{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .hang3{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }
    p,label{margin: 0;padding: 0}
    body{
        background:#ededed;
    }
    .xingqit{
        width: 130px;
        height: 32px;
        line-height: 32px;
        font-size: 16px;
        color: #000;

        border-radius:8px 8px 0 0 ;
        background:#fff ;
        box-shadow: 1px 1px 5px #cdcdcd ;
    }
    .xingqib{
        padding-right: 0;
    }
    .xingqBoxb{
        width: 135px;
        padding: 0;
        /*padding-right: 5px;*/
    }
    .fl{
        float: left;
    }
    .xingqBox{
        width: 125px;
        padding: 0;
        padding-right:10px;

    }
    .kechengka{
        cursor: pointer;
        margin:10px auto 0 ;
        border: 1px solid #eee;
        border-radius: 8px;
        position: relative;
        overflow: hidden;
        padding: 13px 14px 13px;
        box-shadow: 1px 1px 5px #cdcdcd ;
        background: #fff;
        margin-right: 5px;
    }
    .kekastatus{
        height:22px;
        line-height: 22px;
        color: #fff;
        text-align: center;
        width: 100px;
        position: absolute;
        right: -26px;
        top: 10px;
        transform: rotate(40deg);

    }
    .duigou{
        position: absolute;
        top:10px;
        right:10px;
        font-size: 20px;
        color: #999;
    }
    .tanhao{
        position: absolute;
        top:10px;
        right:10px;
        font-size: 20px;
        color: #E6BE8A;
    }

    .kekastatus.active1{
        background: #79c4c7;
    }
    .kekastatus.active2{
        background: #f8e234;
    }
    .kekastatus.active3{
        background: #ff787c;
    }



    .kechengm{
        font-weight: 600;
        width: 95px;
        font-size: 14px;
    }
    .beikeren{
        height: 20px;
        line-height: 20px;
        background: #eee;
        color: #999;
        margin-top:10px;
        border-radius: 8px;
    }
    .text-center{
        text-align: center;
    }

    @media screen and (min-width: 1500px) {
        .xingqit{
            height: 38px;
            line-height: 38px;
            font-size: 18px;
        }
        .kechengka{
            height:90px ;
        }
        .kechengm{
            width: 140px;
        }
        .beikeren{
            margin-top: 18px;
            height: 24px;
            line-height: 24px

        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/jiaoan/jiaoan.vue